"use client";

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from "next-themes";
import * as React from "react";

export function ThemeProvider({ children }: ThemeProviderProps) {
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    setIsLoaded(true);
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <NextThemesProvider
      disableTransitionOnChange
      defaultTheme="system"
      attribute="class"
      enableSystem>
      {children}
    </NextThemesProvider>
  );
}
